import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { API_URL } from 'src/app/shared/constants/apiurl-constants';
import { SessionService } from 'src/app/shared/session-service/session.service';
import { ProjectSurvey } from 'src/app/shared/models/project-survey';
import { SurveyDocument } from 'src/app/survey/models/survey-document.model';

@Injectable({
    providedIn: 'root'
})

export class ProjectSurveyDetailsService {
    constructor(public sessionService: SessionService) { }
    private projecSurveyDetails = new BehaviorSubject<ProjectSurvey>(new ProjectSurvey());
    projectSurveyDetails$ = this.projecSurveyDetails.asObservable();

    private surveyDocuments = new BehaviorSubject<SurveyDocument[]>([]);
    surveyDocument$ = this.surveyDocuments.asObservable();

    getProjectSMEsEmailSentDateDetails(surveyId: number, engagementId: number) {
        return this.sessionService.apiUrlGet(API_URL.SURVEY.GET_SME_EMAIL_SENT_DETAILS + `?surveyId=${surveyId}&engagementId=${engagementId}`);
    }

}
